import { render, staticRenderFns } from "./ValveCollection.vue?vue&type=template&id=1cf6124a&"
import script from "./ValveCollection.vue?vue&type=script&lang=js&"
export * from "./ValveCollection.vue?vue&type=script&lang=js&"
import style0 from "./ValveCollection.vue?vue&type=style&index=0&id=1cf6124a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports